// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"more-m__wrapper__2sxTa","content":"more-m__content__1XWY0"};